import dayjs from "dayjs";

export const getParamUrlByKey = (keyparame) => {
  let search = window.location.search;
  let arr = search.split("?");
  let params = new URLSearchParams(arr[1]);
  let res;

  if (keyparame) {
    res = params.get(keyparame);
  }
  return res;
}

export const formatMoney = (money) => {
  const res = `${money || 0}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  return res;
};

function capitalize(str) {
  if (!str) {
    return "";
  }
  var splitStr = str.toLowerCase().split(" ");
  for (var i = 0; i < splitStr.length; i++) {
    splitStr[i] =
      splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
  }
  return splitStr.join(" ");
}

function _formatDayNoHour(str) {
  if (str) {
    return dayjs(str).format("DD/MM/YYYY");
  }
  return "";
}

function clearLocal() {
  window.localStorage.clear();
  localStorage.removeItem("dataOrderTNGD");
  localStorage.removeItem("listInsuredTNGD");
  localStorage.removeItem("buyerInfoTNGD");
}

const variable = {
  getParamUrlByKey,
  capitalize,
  formatMoney,
  _formatDayNoHour,
  clearLocal
};
export default variable;
